import { lazy } from 'react';

import {
  headerInitialProps,
  heroVariantOneInitialProps,
  aboutVariantInitialProps,
  locationInitialProps,
  footerInitialProps,
  imageGalleryInitialProps,
  featuredMenuInitialProps,
  menuInitialProps,
  dealsVariantOneInitialProps,
  spotlightsInitialProps,
  customSectionInitialProps,
  callToActionVariantOneInitialProps,
  howItWorksInitialProps,
  giftCardsInitialProps,
  tiersInitialProps,
  formInitialProps,
  loyaltyFormInitialProps,
  cateringFormInitialProps,
  infoCardsInitialProps,
  testimonialsVariantOneInitialProps,
  accessibilityInitialProps,
  packagesVariantOneInitialProps,
} from './initialProps';

import HeaderVariantOneSkeleton from '../../icons/Images/Skeletons/Header/Variant_1.png';
import HeaderVariantTwoSkeleton from '../../icons/Images/Skeletons/Header/Variant_2.png';
import HeaderVariantThreeSkeleton from '../../icons/Images/Skeletons/Header/Variant_3.png';
import HeroVariantOneSkeleton from '../../icons/Images/Skeletons/Hero/Variant_1.png';
import HeroVariantTwoSkeleton from '../../icons/Images/Skeletons/Hero/Variant_3.png';
import AboutVariantOneSkeleton from '../../icons/Images/Skeletons/About-Us/Variant_1.png';
import AboutVariantTwoSkeleton from '../../icons/Images/Skeletons/About-Us/Variant_2.png';
import AboutVariantThreeSkeleton from '../../icons/Images/Skeletons/About-Us/variant_3.png';
import LocationVariantOneSkeleton from '../../icons/Images/Skeletons/Location/Variant_1.png';
import LocationVariantTwoSkeleton from '../../icons/Images/Skeletons/Location/Variant_2.png';
import FooterVariantOneSkeleton from '../../icons/Images/Skeletons/Footer/Variant_1.png';
import FooterVariantTwoSkeleton from '../../icons/Images/Skeletons/Footer/Variant_2.png';
import ImageGalleyVariantOneSkeleton from '../../icons/Images/Skeletons/Gallery/Variant_1.png';
import ImageGalleyVariantTwoSkeleton from '../../icons/Images/Skeletons/Gallery/Variant_2.png';
import ImageGalleyVariantThreeSkeleton from '../../icons/Images/Skeletons/Gallery/variant_5.png';
import MenuVariantOneSkeleton from '../../icons/Images/Skeletons/Menu/variant_1.png';
import MenuVariantTwoSkeleton from '../../icons/Images/Skeletons/Menu/variant_2.png';
import MenuVariantThreeSkeleton from '../../icons/Images/Skeletons/Menu/variant_3.png';
import FeaturedMenuVariantFourSkeleton from '../../icons/Images/Skeletons/Menu/variant_4.png';
import DealsVariantOneSkeleton from '../../icons/Images/Skeletons/Deals/Variant_1.png';
import SpotlightsVariantOneSkeleton from '../../icons/Images/Skeletons/Spotlight/Variant_1.png';
import SpotlightsVariantTwoSkeleton from '../../icons/Images/Skeletons/Spotlight/Variant_2.png';
import CustomSectionSkeleton from '../../icons/Images/Skeletons/CustomSection/CustomSection.png';
import CallToActionSkeleton from '../../icons/Images/Skeletons/CallToAction/Variant_1.png';
import FormVariantTwoSkeleton from '../../icons/Images/Skeletons/Form/variant_2.png';
import InfoCardsVariantOneSkeleton from '../../icons/Images/Skeletons/InfoCards/Variant_1.png';
import TestimonialsVariantOneSkeleton from '../../icons/Images/Skeletons/Testimonials/Variant_1.png';

import HEADER_VARIANT_1 from '../../sections/Header/VariantOne';
import HEADER_VARIANT_2 from '../../sections/Header/VariantTwo';
import HEADER_VARIANT_3 from '../../sections/Header/VariantThree';
import HERO_VARIANT_1 from '../../sections/Hero/VariantOne';
import HERO_VARIANT_2 from '../../sections/Hero/VariantTwo';

import { COMPONENT_KEY, IComponentMap, VARIANT_KEY } from './enums';

const ABOUT_VARIANT_1 = lazy(() => import('../../sections/About/VariantOne'));
const ABOUT_VARIANT_2 = lazy(() => import('../../sections/About/VariantTwo'));
const ABOUT_VARIANT_3 = lazy(() => import('../About/VariantThree'));
const LOCATION_VARIANT_1 = lazy(() => import('../../sections/Location/VariantOne'));
const LOCATION_VARIANT_2 = lazy(() => import('../../sections/Location/VariantTwo'));
const LOCATION_VARIANT_3 = lazy(() => import('../../sections/Location/VariantThree'));
const FOOTER_VARIANT_1 = lazy(() => import('../../sections/Footer/VariantOne'));
const FOOTER_VARIANT_2 = lazy(() => import('../../sections/Footer/VariantTwo'));
const MENU_VARIANT_1 = lazy(() => import('../../sections/Menu/VariantOne'));
const MENU_VARIANT_2 = lazy(() => import('../../sections/Menu/VariantTwo'));
const MENU_VARIANT_3 = lazy(() => import('../../sections/Menu/VariantThree'));
const ImageGalleryVariantOne = lazy(() => import('../../sections/ImageGallery/VariantOne'));
const ImageGalleryVariantTwo = lazy(() => import('../../sections/ImageGallery/VariantTwo'));
const ImageGalleryVariantThree = lazy(() => import('../../sections/ImageGallery/VariantThree'));
const FEATURED_MENU_VARIANT_1 = lazy(() => import('../../sections/FeaturedMenu/VariantOne'));
const FEATURED_MENU_VARIANT_2 = lazy(() => import('../../sections/FeaturedMenu/VariantTwo'));
const FEATURED_MENU_VARIANT_3 = lazy(() => import('../../sections/FeaturedMenu/VariantThree'));
const FEATURED_MENU_VARIANT_4 = lazy(() => import('../../sections/FeaturedMenu/VariantFour'));
const DealsVariantOne = lazy(() => import('../../sections/Deals/VariantOne'));
const SpotlightsVariantOne = lazy(() => import('../../sections/Spotlights/VariantOne'));
const SpotlightsVariantTwo = lazy(() => import('../../sections/Spotlights/VariantTwo'));
const CustomSection = lazy(() => import('../../sections/CustomSection'));
const CallToActionVariantOne = lazy(() => import('../../sections/CallToAction/VariantOne'));
const HowItWorksVariantOne = lazy(() => import('../../sections/HowItWorks/VariantOne'));
const TiersVariantOne = lazy(() => import('../../sections/Tiers/VariantOne'));
const GIFTS_VARIANT_1 = lazy(() => import('../../sections/GiftCards/VariantOne'));
const FORM_VARIANT_1 = lazy(() => import('../../sections/Form/VariantOne'));
const FORM_VARIANT_2 = lazy(() => import('../../sections/Form/VariantTwo'));
const LOYALTY_FORM_VARIANT_1 = lazy(() => import('../../sections/LoyalityForm/VariantOne'));
const LOYALTY_FORM_VARIANT_2 = lazy(() => import('../../sections/LoyalityForm/VariantTwo'));
const CATERING_FORM_VARIANT_1 = lazy(() => import('../../sections/CateringForm/VariantOne'));
const InfoCardsVariantOne = lazy(() => import('../../sections/InfoCards/VariantOne'));
const TestimonialsVariantOne = lazy(() => import('../../sections/Testimonials/VariantOne'));
const AccessibilityVariantOne = lazy(() => import('../../sections/Accessibility'));

const ComponentGenerator = (Component: any) => <Component />;

const PackagesVariantOne = lazy(() => import('../../sections/Packages/VariantOne'));
const PackagesVariantOneSkeleton = lazy(() =>
  import('../../sections/Packages/Skeleton/PackagesSkeleton').then((module) => ({ default: module.PackagesSkeleton }))
);

export const COMPONENT_MAP: IComponentMap = {
  [COMPONENT_KEY.HEADER]: {
    [VARIANT_KEY.VARIANT1]: {
      component: ComponentGenerator(HEADER_VARIANT_1),
      initialProps: headerInitialProps,
      skeleton: HeaderVariantOneSkeleton,
    },
    [VARIANT_KEY.VARIANT2]: {
      component: ComponentGenerator(HEADER_VARIANT_2),
      initialProps: headerInitialProps,
      skeleton: HeaderVariantTwoSkeleton,
    },
    [VARIANT_KEY.VARIANT3]: {
      component: ComponentGenerator(HEADER_VARIANT_3),
      initialProps: headerInitialProps,
      skeleton: HeaderVariantThreeSkeleton,
    },
  },
  [COMPONENT_KEY.HERO]: {
    [VARIANT_KEY.VARIANT1]: {
      component: ComponentGenerator(HERO_VARIANT_1),
      initialProps: heroVariantOneInitialProps,
      skeleton: HeroVariantOneSkeleton,
    },
    [VARIANT_KEY.VARIANT2]: {
      component: ComponentGenerator(HERO_VARIANT_2),
      initialProps: heroVariantOneInitialProps,
      skeleton: HeroVariantTwoSkeleton,
    },
  },
  [COMPONENT_KEY.LOCATION]: {
    [VARIANT_KEY.VARIANT1]: {
      component: ComponentGenerator(LOCATION_VARIANT_1),
      initialProps: locationInitialProps,
      skeleton: LocationVariantOneSkeleton,
    },
    [VARIANT_KEY.VARIANT2]: {
      component: ComponentGenerator(LOCATION_VARIANT_2),
      initialProps: locationInitialProps,
      skeleton: LocationVariantOneSkeleton,
    },
    [VARIANT_KEY.VARIANT3]: {
      component: ComponentGenerator(LOCATION_VARIANT_3),
      initialProps: locationInitialProps,
      skeleton: LocationVariantTwoSkeleton,
    },
  },
  [COMPONENT_KEY.ABOUT_US]: {
    [VARIANT_KEY.VARIANT1]: {
      component: ComponentGenerator(ABOUT_VARIANT_1),
      initialProps: aboutVariantInitialProps,
      skeleton: AboutVariantOneSkeleton,
    },
    [VARIANT_KEY.VARIANT2]: {
      component: ComponentGenerator(ABOUT_VARIANT_2),
      initialProps: aboutVariantInitialProps,
      skeleton: AboutVariantTwoSkeleton,
    },
    [VARIANT_KEY.VARIANT3]: {
      component: ComponentGenerator(ABOUT_VARIANT_3),
      initialProps: aboutVariantInitialProps,
      skeleton: AboutVariantThreeSkeleton,
    },
  },
  [COMPONENT_KEY.FOOTER]: {
    [VARIANT_KEY.VARIANT1]: {
      component: ComponentGenerator(FOOTER_VARIANT_1),
      initialProps: footerInitialProps,
      skeleton: FooterVariantOneSkeleton,
    },
    [VARIANT_KEY.VARIANT2]: {
      component: ComponentGenerator(FOOTER_VARIANT_2),
      initialProps: footerInitialProps,
      skeleton: FooterVariantTwoSkeleton,
    },
  },
  [COMPONENT_KEY.IMAGE_GALLERY]: {
    [VARIANT_KEY.VARIANT1]: {
      component: ComponentGenerator(ImageGalleryVariantOne),
      initialProps: imageGalleryInitialProps,
      skeleton: ImageGalleyVariantOneSkeleton,
    },
    [VARIANT_KEY.VARIANT2]: {
      component: ComponentGenerator(ImageGalleryVariantTwo),
      initialProps: imageGalleryInitialProps,
      skeleton: ImageGalleyVariantTwoSkeleton,
    },
    [VARIANT_KEY.VARIANT3]: {
      component: ComponentGenerator(ImageGalleryVariantThree),
      initialProps: imageGalleryInitialProps,
      skeleton: ImageGalleyVariantThreeSkeleton,
    },
  },
  [COMPONENT_KEY.FEATURED_MENU]: {
    [VARIANT_KEY.VARIANT1]: {
      component: ComponentGenerator(FEATURED_MENU_VARIANT_1),
      initialProps: featuredMenuInitialProps,
      skeleton: MenuVariantOneSkeleton,
    },
    [VARIANT_KEY.VARIANT2]: {
      component: ComponentGenerator(FEATURED_MENU_VARIANT_2),
      initialProps: featuredMenuInitialProps,
      skeleton: MenuVariantTwoSkeleton,
    },
    [VARIANT_KEY.VARIANT3]: {
      component: ComponentGenerator(FEATURED_MENU_VARIANT_3),
      initialProps: featuredMenuInitialProps,
      skeleton: MenuVariantThreeSkeleton,
    },
    [VARIANT_KEY.VARIANT4]: {
      component: ComponentGenerator(FEATURED_MENU_VARIANT_4),
      initialProps: featuredMenuInitialProps,
      skeleton: FeaturedMenuVariantFourSkeleton,
    },
  },
  [COMPONENT_KEY.DEALS]: {
    [VARIANT_KEY.VARIANT1]: {
      component: ComponentGenerator(DealsVariantOne),
      initialProps: dealsVariantOneInitialProps,
      skeleton: DealsVariantOneSkeleton,
    },
  },
  [COMPONENT_KEY.SPOTLIGHTS]: {
    [VARIANT_KEY.VARIANT1]: {
      component: ComponentGenerator(SpotlightsVariantOne),
      initialProps: spotlightsInitialProps,
      skeleton: SpotlightsVariantOneSkeleton,
    },
    [VARIANT_KEY.VARIANT2]: {
      component: ComponentGenerator(SpotlightsVariantTwo),
      initialProps: spotlightsInitialProps,
      skeleton: SpotlightsVariantTwoSkeleton,
    },
  },
  [COMPONENT_KEY.CUSTOM_SECTION]: {
    [VARIANT_KEY.VARIANT1]: {
      component: ComponentGenerator(CustomSection),
      initialProps: customSectionInitialProps,
      skeleton: CustomSectionSkeleton,
    },
  },
  [COMPONENT_KEY.MENU]: {
    [VARIANT_KEY.VARIANT1]: {
      component: ComponentGenerator(MENU_VARIANT_1),
      initialProps: menuInitialProps,
      skeleton: MenuVariantOneSkeleton,
    },
    [VARIANT_KEY.VARIANT2]: {
      component: ComponentGenerator(MENU_VARIANT_2),
      initialProps: menuInitialProps,
      skeleton: MenuVariantTwoSkeleton,
    },
    [VARIANT_KEY.VARIANT3]: {
      component: ComponentGenerator(MENU_VARIANT_3),
      initialProps: menuInitialProps,
      skeleton: MenuVariantThreeSkeleton,
    },
  },
  [COMPONENT_KEY.CALL_TO_ACTION]: {
    [VARIANT_KEY.VARIANT1]: {
      component: ComponentGenerator(CallToActionVariantOne),
      initialProps: callToActionVariantOneInitialProps,
      skeleton: CallToActionSkeleton,
    },
  },
  [COMPONENT_KEY.HOW_IT_WORKS]: {
    [VARIANT_KEY.VARIANT1]: {
      component: ComponentGenerator(HowItWorksVariantOne),
      initialProps: howItWorksInitialProps,
      skeleton: '',
    },
  },
  [COMPONENT_KEY.TIERS_POINTS]: {
    [VARIANT_KEY.VARIANT1]: {
      component: ComponentGenerator(TiersVariantOne),
      initialProps: tiersInitialProps,
      skeleton: MenuVariantOneSkeleton,
    },
  },

  [COMPONENT_KEY.GIFT_CARDS]: {
    [VARIANT_KEY.VARIANT1]: {
      component: ComponentGenerator(GIFTS_VARIANT_1),
      initialProps: giftCardsInitialProps,
      skeleton: '',
    },
  },

  [COMPONENT_KEY.FORM]: {
    [VARIANT_KEY.VARIANT1]: {
      component: ComponentGenerator(FORM_VARIANT_1),
      initialProps: formInitialProps,
      skeleton: CallToActionSkeleton,
    },
    [VARIANT_KEY.VARIANT2]: {
      component: ComponentGenerator(FORM_VARIANT_2),
      initialProps: formInitialProps,
      skeleton: FormVariantTwoSkeleton,
    },
  },

  [COMPONENT_KEY.LOYALTY_FORM]: {
    [VARIANT_KEY.VARIANT1]: {
      component: ComponentGenerator(LOYALTY_FORM_VARIANT_1),
      initialProps: loyaltyFormInitialProps,
      skeleton: CallToActionSkeleton,
    },
    [VARIANT_KEY.VARIANT2]: {
      component: ComponentGenerator(LOYALTY_FORM_VARIANT_2),
      initialProps: loyaltyFormInitialProps,
      skeleton: FormVariantTwoSkeleton,
    },
  },
  [COMPONENT_KEY.CATERING_FORM]: {
    [VARIANT_KEY.VARIANT1]: {
      component: ComponentGenerator(CATERING_FORM_VARIANT_1),
      initialProps: cateringFormInitialProps,
      skeleton: CallToActionSkeleton,
    },
  },

  [COMPONENT_KEY.INFO_CARDS]: {
    [VARIANT_KEY.VARIANT1]: {
      component: ComponentGenerator(InfoCardsVariantOne),
      initialProps: infoCardsInitialProps,
      skeleton: InfoCardsVariantOneSkeleton,
    },
  },
  [COMPONENT_KEY.TESTIMONIALS]: {
    [VARIANT_KEY.VARIANT1]: {
      component: ComponentGenerator(TestimonialsVariantOne),
      initialProps: testimonialsVariantOneInitialProps,
      skeleton: TestimonialsVariantOneSkeleton,
    },
  },

  [COMPONENT_KEY.ACCESSIBILITY]: {
    [VARIANT_KEY.VARIANT1]: {
      component: ComponentGenerator(AccessibilityVariantOne),
      initialProps: accessibilityInitialProps,
      skeleton: '',
    },
  },
  [COMPONENT_KEY.PACKAGES]: {
    [VARIANT_KEY.VARIANT1]: {
      component: ComponentGenerator(PackagesVariantOne),
      initialProps: packagesVariantOneInitialProps,
      skeleton: PackagesVariantOneSkeleton,
    },
  },
};
